import { CheckRingDuotoneLine } from '@repo/go-icons';
import { RadioGroup, Tooltip } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';

import type { Wellbore } from '../../api/IDashboardService';

import styles from './SelectableWellboreList.module.css';

type Props = {
  wellbores: Wellbore[];
  onChange: (wellboreId: number) => void;
  value?: number | null;
  activeTitle: string;
};

export const SelectableWellboreList = observer(function WellboreSelect({
  wellbores,
  onChange,
  value,
  activeTitle: title,
}: Props) {
  return (
    <RadioGroup
      style={{ padding: 8 }}
      onChange={(value) => {
        onChange(Number(value));
      }}
      value={value}
      items={wellbores.map((bore) => {
        return {
          label: (
            <div className={styles.Label}>
              {bore.specialName}
              {bore.active && (
                <Tooltip title={title}>
                  <CheckRingDuotoneLine className={styles.ActiveLabelIcon} />
                </Tooltip>
              )}
            </div>
          ),
          value: bore.id,
        };
      })}
    />
  );
});
